export const reasons = {
  JP: [
    {
      number: "01",
      icon: "private",
      label: "Private",
      title: "完全貸切プライベート制",
      description:
        "すべてのプランは1組限定。周りを気にせず、自分たちだけのペースでゆっくり楽しめます。他に人がいない秘境スポットで、宮古島の絶景を独り占めできます。贅沢すぎる究極の非日常体験を！",
    },
    {
      number: "02",
      icon: "spot",
      label: "Secret Spot",
      title: "撮影品質保証",
      description:
        "当日の天候や海況を確認し、十分な撮影コンディションでご案内できないと判断した場合は、キャンセル料無料で中止または日程変更をご提案します。安心してご予約ください。",
    },
    {
      number: "03",
      icon: "shuttle",
      label: "Free Shuttle",
      title: "無料送迎",
      description: "秘境フォトプランは無料送迎付き。どこでもお迎えにあがります。",
    },
    {
      number: "04",
      icon: "camera",
      label: "Photo & Movie",
      title: "高クオリティ写真・動画",
      description:
        "プロ仕様の機材で、旅の思い出を高クオリティに撮影。SNSに載せたくなる写真と動画は、全てここで撮れます。",
    },
  ],

  EN: [
    {
      number: "01",
      icon: "private",
      label: "Private",
      title: "Private Tours Only",
      description:
        "Every tour is exclusively for one group. Relax without crowds and enjoy carefully selected quiet locations.",
    },
    {
      number: "02",
      icon: "spot",
      label: "Secret Spot",
      title: "Shooting Condition Guarantee",
      description:
        "We check the weather and sea conditions on the day. If we decide that the shooting conditions are not suitable, we will cancel or suggest rescheduling with no cancellation fee.",
    },
    {
      number: "03",
      icon: "shuttle",
      label: "Free Shuttle",
      title: "Free Pick-up Service",
      description:
        "Free transportation is included with the Hidden Photo Plan. We can pick you up anywhere on Miyakoisland.",
    },
    {
      number: "04",
      icon: "camera",
      label: "Photo & Movie",
      title: "Professional Photos & Videos",
      description:
        "We use professional equipment to capture photos you will want to share and videos you will want to look back on forever.",
    },
  ],

  中文: [
    {
      number: "01",
      icon: "private",
      label: "Private",
      title: "完全私人包团",
      description:
        "所有行程均为一组客人专享，不与他人拼团，可悠闲享受宁静的秘境。",
    },
    {
      number: "02",
      icon: "spot",
      label: "Secret Spot",
      title: "拍摄条件保障",
      description:
        "我们会根据当天的天气和海况判断拍摄条件。如果不适合拍摄，将免费取消或建议改期。",
    },
    {
      number: "03",
      icon: "shuttle",
      label: "Free Shuttle",
      title: "免费接送",
      description: "秘境摄影方案包含免费接送服务，可前往宫古岛任何地点接送。",
    },
    {
      number: "04",
      icon: "camera",
      label: "Photo & Movie",
      title: "高品质照片与影片",
      description:
        "使用专业级器材拍摄，为您留下想分享到社交平台的照片，以及值得反复回看的影片。",
    },
  ],

  한국어: [
    {
      number: "01",
      icon: "private",
      label: "Private",
      title: "완전 프라이빗 투어",
      description:
        "모든 투어는 한 팀만 이용합니다. 다른 사람을 신경 쓰지 않고 여유롭게 즐길 수 있습니다.",
    },
    {
      number: "02",
      icon: "spot",
      label: "Secret Spot",
      title: "촬영 컨디션 보장",
      description:
        "당일 날씨와 바다 상황을 확인해 촬영 컨디션이 충분하지 않다고 판단되면 취소 수수료 없이 취소하거나 일정 변경을 안내합니다.",
    },
    {
      number: "03",
      icon: "shuttle",
      label: "Free Shuttle",
      title: "무료 픽업 서비스",
      description:
        "비경 포토 플랜에는 무료 픽업이 포함되어 있으며, 미야코섬 어디든 모시러 갑니다.",
    },
    {
      number: "04",
      icon: "camera",
      label: "Photo & Movie",
      title: "고퀄리티 사진 & 영상",
      description:
        "전문 장비로 SNS에 올리고 싶은 사진과 오래도록 다시 보고 싶은 영상을 남겨 드립니다.",
    },
  ],
};
